"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.observe = observe;
exports.unobserve = unobserve;
var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));
/* eslint-disable no-unused-expressions */
// eslint-disable-next-line import/no-extraneous-dependencies

// =============================== Const ===============================
var elementListeners = new Map();
function onResize(entities) {
  entities.forEach(function (entity) {
    var _a;
    var target = entity.target;
    (_a = elementListeners.get(target)) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) {
      return listener(target);
    });
  });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var resizeObserver = new _resizeObserverPolyfill["default"](onResize);
// ============================== Observe ==============================
function observe(element, callback) {
  var _a;
  if (!elementListeners.has(element)) {
    elementListeners.set(element, new Set());
    resizeObserver.observe(element);
  }
  (_a = elementListeners.get(element)) === null || _a === void 0 ? void 0 : _a.add(callback);
}
function unobserve(element, callback) {
  var _a, _b;
  if (elementListeners.has(element)) {
    if (callback) {
      (_a = elementListeners.get(element)) === null || _a === void 0 ? void 0 : _a["delete"](callback);
    }
    if (!((_b = elementListeners.get(element)) === null || _b === void 0 ? void 0 : _b.size) || !callback) {
      resizeObserver.unobserve(element);
      elementListeners["delete"](element);
    }
  }
}